<template>
  <div class="comparativo-grupos">
    <div
      ref="picker"
      class="picker"
      :class="{ 'is-stuck': isStuck }"
      :style="{ top: pickerTopOffset + 'px' }"
    >
      <div class="picker-compact-label">
        Comparativo <span aria-hidden="true">→</span>
      </div>

      <div class="picker-card a">
        <div class="picker-label">
          <span class="id-badge">A</span>
          <span class="picker-label-text">Grupo A</span>
        </div>
        <div ref="gselA" class="gsel" :class="{ open: openA }">
          <button
            type="button"
            class="gsel-trigger"
            aria-haspopup="listbox"
            :aria-expanded="openA"
            @click="togglePanel('A')"
          >
            <span class="gsel-trigger-value">
              <template v-if="selectedA && selectedA.isTotal">
                <span class="gsel-trigger-sub">{{ selectedA.name }}</span>
              </template>
              <template v-else-if="selectedA">
                <span class="gsel-trigger-dep">{{ selectedA.group }}</span>
                <span class="gsel-trigger-sep">·</span>
                <span class="gsel-trigger-sub">{{ selectedA.name }}</span>
              </template>
              <template v-else>Selecciona un subgrupo…</template>
            </span>
            <svg
              class="gsel-caret"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              aria-hidden="true"
            >
              <path
                d="M1 3l4 4 4-4"
                stroke="currentColor"
                stroke-width="1.6"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <div v-if="openA" class="gsel-panel">
            <input
              ref="searchA"
              v-model="searchA"
              type="text"
              class="gsel-search"
              placeholder="Buscar dependencia o subgrupo…"
              autocomplete="off"
            />
            <div
              class="gsel-option gsel-total-option"
              @click="onSelect('A', makeTotalOption())"
            >
              <span>Total (todos los encuestados)</span>
            </div>
            <div class="gsel-list">
              <template v-if="groupedOptions(searchA).length">
                <div
                  v-for="grp in groupedOptions(searchA)"
                  :key="grp.group"
                  class="gsel-group"
                >
                  <div class="gsel-group-label">{{ grp.group }}</div>
                  <div
                    v-for="opt in grp.items"
                    :key="opt.id"
                    class="gsel-option"
                    @click="onSelect('A', opt)"
                  >
                    <span>
                      {{ opt.name }}
                      <span
                        v-if="opt.empty"
                        class="gsel-option-warning"
                        title="Datos insuficientes (n ≤ 4)"
                        >⚠</span
                      >
                    </span>
                    <span class="gsel-option-n">n={{ opt.n }}</span>
                  </div>
                </div>
              </template>
              <div v-else class="gsel-empty">Sin resultados</div>
            </div>
          </div>
        </div>
        <div
          class="picker-stat"
          :class="{ 'is-insufficient': selectedA && selectedA.empty }"
        >
          <span class="picker-stat-label">Participantes válidos</span>
          <span class="picker-stat-compact-label" title="Participantes válidos">
            N
          </span>
          <span class="picker-stat-value">{{
            selectedA ? selectedA.n : "—"
          }}</span>
          <span v-if="selectedA && selectedA.empty" class="picker-stat-warning">
            ⚠ Insuficiente — mínimo 5 encuestas
          </span>
        </div>
      </div>

      <div class="picker-card b">
        <div class="picker-label">
          <span class="id-badge">B</span>
          <span class="picker-label-text">Grupo B</span>
        </div>
        <div ref="gselB" class="gsel" :class="{ open: openB }">
          <button
            type="button"
            class="gsel-trigger"
            aria-haspopup="listbox"
            :aria-expanded="openB"
            @click="togglePanel('B')"
          >
            <span class="gsel-trigger-value">
              <template v-if="selectedB && selectedB.isTotal">
                <span class="gsel-trigger-sub">{{ selectedB.name }}</span>
              </template>
              <template v-else-if="selectedB">
                <span class="gsel-trigger-dep">{{ selectedB.group }}</span>
                <span class="gsel-trigger-sep">·</span>
                <span class="gsel-trigger-sub">{{ selectedB.name }}</span>
              </template>
              <template v-else>Selecciona un subgrupo…</template>
            </span>
            <svg
              class="gsel-caret"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              aria-hidden="true"
            >
              <path
                d="M1 3l4 4 4-4"
                stroke="currentColor"
                stroke-width="1.6"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <div v-if="openB" class="gsel-panel">
            <input
              ref="searchB"
              v-model="searchB"
              type="text"
              class="gsel-search"
              placeholder="Buscar dependencia o subgrupo…"
              autocomplete="off"
            />
            <div
              class="gsel-option gsel-total-option"
              @click="onSelect('B', makeTotalOption())"
            >
              <span>Total (todos los encuestados)</span>
            </div>
            <div class="gsel-list">
              <template v-if="groupedOptions(searchB).length">
                <div
                  v-for="grp in groupedOptions(searchB)"
                  :key="grp.group"
                  class="gsel-group"
                >
                  <div class="gsel-group-label">{{ grp.group }}</div>
                  <div
                    v-for="opt in grp.items"
                    :key="opt.id"
                    class="gsel-option"
                    @click="onSelect('B', opt)"
                  >
                    <span>
                      {{ opt.name }}
                      <span
                        v-if="opt.empty"
                        class="gsel-option-warning"
                        title="Datos insuficientes (n ≤ 4)"
                        >⚠</span
                      >
                    </span>
                    <span class="gsel-option-n">n={{ opt.n }}</span>
                  </div>
                </div>
              </template>
              <div v-else class="gsel-empty">Sin resultados</div>
            </div>
          </div>
        </div>
        <div
          class="picker-stat"
          :class="{ 'is-insufficient': selectedB && selectedB.empty }"
        >
          <span class="picker-stat-label">Participantes válidos</span>
          <span class="picker-stat-compact-label" title="Participantes válidos">
            N
          </span>
          <span class="picker-stat-value">{{
            selectedB ? selectedB.n : "—"
          }}</span>
          <span v-if="selectedB && selectedB.empty" class="picker-stat-warning">
            ⚠ Insuficiente — mínimo 5 encuestas
          </span>
        </div>
      </div>
    </div>

    <p class="comparativo-threshold-note">
      Se destaca el grupo que supera al otro por más de 1.5 puntos
      porcentuales. Las diferencias menores se consideran un empate y no se
      destaca ninguna de las dos dependencias.
    </p>

    <div
      class="picker-spacer"
      :style="{ height: pickerSpacerHeight + 'px' }"
    ></div>

    <div
      v-if="!selectedA || !selectedB"
      class="notification is-light has-text-centered"
    >
      Selecciona un Grupo A y un Grupo B para comparar.
    </div>

    <div
      v-else-if="selectedA.empty || selectedB.empty"
      class="notification is-warning is-light"
    >
      Uno de los grupos seleccionados no tiene suficientes encuestas válidas
      (mínimo 5) para calcular resultados.
    </div>

    <div v-else-if="loading" class="has-text-centered comparativo-loading">
      <p>Cargando comparación…</p>
      <progress class="progress is-small is-primary"></progress>
    </div>

    <div v-else-if="detailA && detailB">
      <div v-if="false" class="comparativo-insights">
        <p class="comparativo-insights-title">
          Mayores diferencias por cuadrante
        </p>
        <div class="comparativo-insight-sides">
          <div class="comparativo-insight-side side-a">
            <div class="comparativo-insight-head">
              <span class="id-badge">A</span>
              <span class="comparativo-insight-side-title">
                Favorece a {{ selectedA.name }}
              </span>
            </div>
            <div class="comparativo-gap-list">
              <template v-if="gaps.forA.length">
                <div
                  v-for="g in gaps.forA"
                  :key="g.key"
                  class="comparativo-gap-row"
                >
                  <span class="comparativo-gap-name">{{ g.name }}</span>
                  <span class="comparativo-gap-value">
                    +{{ fmt1(g.d) }} pts
                  </span>
                </div>
              </template>
              <p v-else class="comparativo-gap-empty">
                Sin diferencias relevantes en el top 3.
              </p>
            </div>
          </div>
          <div class="comparativo-insight-side side-b">
            <div class="comparativo-insight-head">
              <span class="id-badge">B</span>
              <span class="comparativo-insight-side-title">
                Favorece a {{ selectedB.name }}
              </span>
            </div>
            <div class="comparativo-gap-list">
              <template v-if="gaps.forB.length">
                <div
                  v-for="g in gaps.forB"
                  :key="g.key"
                  class="comparativo-gap-row"
                >
                  <span class="comparativo-gap-name">{{ g.name }}</span>
                  <span class="comparativo-gap-value">
                    +{{ fmt1(-g.d) }} pts
                  </span>
                </div>
              </template>
              <p v-else class="comparativo-gap-empty">
                Sin diferencias relevantes en el top 3.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr class="has-text-dark" style="margin: 15px 0" />

      <div class="comparativo-mirror">
        <div class="mirror-row mirror-header">
          <div class="mirror-row-title"></div>
          <div class="mirror-track">
            <div class="mirror-half left">
              <span class="mirror-header-label">
                {{ groupLabel(selectedA) }}
              </span>
            </div>
            <span class="mirror-divider-dot"></span>
            <div class="mirror-half right">
              <span class="mirror-header-label">
                {{ groupLabel(selectedB) }}
              </span>
            </div>
          </div>
        </div>

        <div class="mirror-block">
          <div
            v-for="row in primaryRows"
            :key="row.key"
            class="mirror-row"
            :class="'is-' + row.kind"
          >
            <div class="mirror-row-title">{{ row.name }}</div>
            <div class="mirror-track">
              <div
                class="mirror-half left"
                :class="{ 'is-winner': winnerSide(row.key) === 'a' }"
              >
                <span class="mirror-val">{{ fmt1(valueA(row.key)) }}%</span>
                <div
                  class="mirror-bar"
                  v-tooltip.top="{
                    content: tooltipHtml(
                      row.name,
                      selectedA.name,
                      valueA(row.key),
                      detailA,
                      row.key,
                      'a',
                    ),
                    classes: ['mirror-bar-tooltip'],
                    html: true,
                  }"
                  :style="{
                    width: barWidth(valueA(row.key)) + '%',
                    background: rangoColor(valueA(row.key)),
                  }"
                ></div>
              </div>
              <div class="mirror-axis"></div>
              <div
                class="mirror-half right"
                :class="{ 'is-winner': winnerSide(row.key) === 'b' }"
              >
                <div
                  class="mirror-bar"
                  v-tooltip.top="{
                    content: tooltipHtml(
                      row.name,
                      selectedB.name,
                      valueB(row.key),
                      detailB,
                      row.key,
                      'b',
                    ),
                    classes: ['mirror-bar-tooltip'],
                    html: true,
                  }"
                  :style="{
                    width: barWidth(valueB(row.key)) + '%',
                    background: rangoColor(valueB(row.key)),
                  }"
                ></div>
                <span class="mirror-val">{{ fmt1(valueB(row.key)) }}%</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mirror-divider">
          <div class="mirror-row-title"></div>
          <div class="mirror-divider-track">
            <span class="mirror-divider-dot"></span>
            <span class="mirror-divider-label">Dimensiones centrales</span>
            <span class="mirror-divider-dot"></span>
          </div>
        </div>

        <div class="mirror-block">
          <div
            v-for="row in centralRows"
            :key="row.key"
            class="mirror-row"
            :class="'is-' + row.kind"
          >
            <div class="mirror-row-title">{{ row.name }}</div>
            <div class="mirror-track">
              <div
                class="mirror-half left"
                :class="{ 'is-winner': winnerSide(row.key) === 'a' }"
              >
                <span class="mirror-val">{{ fmt1(valueA(row.key)) }}%</span>
                <div
                  class="mirror-bar"
                  v-tooltip.top="{
                    content: tooltipHtml(
                      row.name,
                      selectedA.name,
                      valueA(row.key),
                      detailA,
                      row.key,
                      'a',
                    ),
                    classes: ['mirror-bar-tooltip'],
                    html: true,
                  }"
                  :style="{
                    width: barWidth(valueA(row.key)) + '%',
                    background: rangoColor(valueA(row.key)),
                  }"
                ></div>
              </div>
              <div class="mirror-axis"></div>
              <div
                class="mirror-half right"
                :class="{ 'is-winner': winnerSide(row.key) === 'b' }"
              >
                <div
                  class="mirror-bar"
                  v-tooltip.top="{
                    content: tooltipHtml(
                      row.name,
                      selectedB.name,
                      valueB(row.key),
                      detailB,
                      row.key,
                      'b',
                    ),
                    classes: ['mirror-bar-tooltip'],
                    html: true,
                  }"
                  :style="{
                    width: barWidth(valueB(row.key)) + '%',
                    background: rangoColor(valueB(row.key)),
                  }"
                ></div>
                <span class="mirror-val">{{ fmt1(valueB(row.key)) }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";

const QUADRANTS = [
  { key: "apoyod", name: "Apoyo", dims: ["apsd", "vincd", "apod"] },
  { key: "innovaciond", name: "Innovación", dims: ["autd", "agid", "mejd"] },
  { key: "calidadd", name: "Calidad", dims: ["excd", "cycd", "segd"] },
  { key: "metasd", name: "Metas", dims: ["logrd", "servd", "repd"] },
];
const CENTRAL = ["lidd", "recd", "compd", "engad"];
const INSIGHT_BUCKETS = QUADRANTS.map((q) => ({
  key: q.key,
  dims: q.dims,
})).concat(CENTRAL.map((k) => ({ key: k, dims: [k] })));
const PICKER_TOP_OFFSET = 50;
const WINNER_THRESHOLD = 1.5;
const LEVELS = ["Muy bajo", "Bajo", "Medio", "Alto", "Muy alto"];
const LEVEL_COLOR = {
  "Muy bajo": "#a6bddb",
  Bajo: "#74a9cf",
  Medio: "#3690c0",
  Alto: "#0570b0",
  "Muy alto": "#045a8d",
};

function escapeHtml(str) {
  return String(str).replace(
    /[&<>"']/g,
    (ch) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[ch]),
  );
}

export default {
  name: "GroupComparison",
  props: {
    groups: {
      type: Array,
      required: true,
    },
    proceso: {
      type: Object,
      required: true,
    },
    namevars: {
      type: Object,
      required: true,
    },
    nombrerangos: {
      type: Object,
      required: true,
    },
    rangos: {
      type: Function,
      required: true,
    },
    processValuesCal: {
      type: Function,
      required: true,
    },
    summaryTotal: {
      type: Object,
      required: true,
    },
    infoProcessTotal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      searchA: "",
      searchB: "",
      openA: false,
      openB: false,
      isStuck: false,
      pickerCurrentHeight: 0,
      pickerExpandedHeight: 0,
      selectedA: null,
      selectedB: null,
      detailA: null,
      detailB: null,
      loadingA: false,
      loadingB: false,
    };
  },
  computed: {
    pickerTopOffset() {
      return PICKER_TOP_OFFSET;
    },
    loading() {
      return this.loadingA || this.loadingB;
    },
    pickerSpacerHeight() {
      if (!this.isStuck) return 0;
      return Math.max(0, this.pickerExpandedHeight - this.pickerCurrentHeight);
    },
    primaryRows() {
      const rows = [{ key: "CClimad", name: "Total Clima", kind: "total" }];
      QUADRANTS.forEach((q) => {
        rows.push({ key: q.key, name: q.name, kind: "quadrant" });
        q.dims.forEach((d) => {
          rows.push({ key: d, name: this.namevars[d], kind: "dim" });
        });
      });
      return rows;
    },
    centralRows() {
      return CENTRAL.map((d) => ({
        key: d,
        name: this.namevars[d],
        kind: d === "engad" ? "quadrant" : "central",
      }));
    },
    gaps() {
      if (!this.detailA || !this.detailB) return { forA: [], forB: [] };
      const candidates = INSIGHT_BUCKETS.map((bucket) => {
        let best = null;
        bucket.dims.forEach((k) => {
          const d = this.valueA(k) - this.valueB(k);
          if (!best || Math.abs(d) > Math.abs(best.d)) {
            best = { key: k, name: this.namevars[k], d };
          }
        });
        return best;
      });
      const forA = candidates
        .filter((x) => x.d > 0)
        .sort((x, y) => y.d - x.d)
        .slice(0, 3);
      const forB = candidates
        .filter((x) => x.d < 0)
        .sort((x, y) => x.d - y.d)
        .slice(0, 3);
      return { forA, forB };
    },
  },
  mounted() {
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
    if ("ResizeObserver" in window && this.$refs.picker) {
      this.pickerResizeObserver = new ResizeObserver(() => {
        if (!this.$refs.picker) return;
        const h = this.$refs.picker.offsetHeight;
        this.pickerCurrentHeight = h;
        if (!this.isStuck) this.pickerExpandedHeight = h;
      });
      this.pickerResizeObserver.observe(this.$refs.picker);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
    window.removeEventListener("scroll", this.onScroll);
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    if (this.pickerResizeObserver) this.pickerResizeObserver.disconnect();
  },
  methods: {
    groupedOptions(term) {
      const q = (term || "").trim().toLowerCase();
      const byDep = {};
      this.groups.forEach((row) => {
        if (
          q &&
          row.name.toLowerCase().indexOf(q) === -1 &&
          row.group.toLowerCase().indexOf(q) === -1
        ) {
          return;
        }
        if (!byDep[row.group]) byDep[row.group] = [];
        byDep[row.group].push(row);
      });
      return Object.keys(byDep).map((dep) => ({
        group: dep,
        items: byDep[dep],
      }));
    },
    makeTotalOption() {
      return {
        group: "",
        name: "Total",
        isTotal: true,
        id: "__total__",
        n: null,
        empty: false,
      };
    },
    groupLabel(sel) {
      if (!sel) return "";
      return sel.isTotal ? sel.name : `${sel.group} · ${sel.name}`;
    },
    togglePanel(side) {
      if (side === "A") {
        this.openB = false;
        this.openA = !this.openA;
        if (this.openA) {
          this.searchA = "";
          this.$nextTick(() => {
            if (this.$refs.searchA) this.$refs.searchA.focus();
          });
        }
      } else {
        this.openA = false;
        this.openB = !this.openB;
        if (this.openB) {
          this.searchB = "";
          this.$nextTick(() => {
            if (this.$refs.searchB) this.$refs.searchB.focus();
          });
        }
      }
    },
    onSelect(side, option) {
      if (!option) return;
      if (side === "A") {
        this.selectedA = option;
        this.openA = false;
      } else {
        this.selectedB = option;
        this.openB = false;
      }
    },
    onDocumentClick(e) {
      if (this.$refs.gselA && !this.$refs.gselA.contains(e.target)) {
        this.openA = false;
      }
      if (this.$refs.gselB && !this.$refs.gselB.contains(e.target)) {
        this.openB = false;
      }
    },
    onKeydown(e) {
      if (e.key === "Escape") {
        this.openA = false;
        this.openB = false;
      }
    },
    onScroll() {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (!this.$refs.picker) return;
        this.isStuck =
          this.$refs.picker.getBoundingClientRect().top <= PICKER_TOP_OFFSET;
      });
    },
    async fetchDetail(side) {
      const row = side === "A" ? this.selectedA : this.selectedB;
      const loadingKey = side === "A" ? "loadingA" : "loadingB";
      const detailKey = side === "A" ? "detailA" : "detailB";
      if (!row || row.empty) {
        this[detailKey] = null;
        return;
      }
      if (row.isTotal) {
        // Mismo dato ya calculado que alimenta el tablero general de
        // Priorización — no se vuelve a pedir al backend.
        this[detailKey] = this.summaryTotal;
        // N real de encuestas válidas (conteo de Mongo), no
        // summaryTotal.total.CClimad.n1: ese es una suma de porcentajes de
        // las 15 dimensiones (siempre ~1500), no un conteo de personas.
        const n = this.infoProcessTotal ? this.infoProcessTotal.totalValid : 0;
        row.n = n;
        row.empty = n <= 4;
        return;
      }
      this[loadingKey] = true;
      try {
        const filters = {};
        filters[row.group] = [row.name];
        const result = await apiServices.post("/traecalculoclima", {
          proceso: this.proceso._id,
          filters,
        });
        this[detailKey] = this.processValuesCal(result.data.calculos);
      } catch (err) {
        console.log(err);
        this[detailKey] = null;
      } finally {
        this[loadingKey] = false;
      }
    },
    valueA(key) {
      return this.detailA && this.detailA.total[key]
        ? this.detailA.total[key].p
        : 0;
    },
    valueB(key) {
      return this.detailB && this.detailB.total[key]
        ? this.detailB.total[key].p
        : 0;
    },
    barWidth(value) {
      return Math.max(4, value || 0);
    },
    diffAbs(key) {
      return Math.abs(this.valueA(key) - this.valueB(key));
    },
    winnerSide(key) {
      const diff = this.valueA(key) - this.valueB(key);
      if (diff > WINNER_THRESHOLD) return "a";
      if (-diff > WINNER_THRESHOLD) return "b";
      return null;
    },
    rangoColor(value) {
      return `var(--clima-${this.rangos(value)})`;
    },
    distributionHtml(detail, key) {
      const stats = detail && detail.total[key];
      if (!stats || !stats.n1) {
        return '<div class="mbtt-empty">Sin datos suficientes</div>';
      }
      const bar = LEVELS.map((lvl) => {
        const pct = (stats[lvl] * 100) / stats.n1;
        return `<span style="width:${pct.toFixed(1)}%;background:${
          LEVEL_COLOR[lvl]
        }"></span>`;
      }).join("");
      const legend = LEVELS.map((lvl) => {
        const pct = (stats[lvl] * 100) / stats.n1;
        return `<div class="mbtt-item"><i class="mbtt-dot" style="background:${
          LEVEL_COLOR[lvl]
        }"></i>${lvl} <span class="mbtt-val">${pct.toFixed(1)}%</span></div>`;
      }).join("");
      return `<div class="mbtt-bar">${bar}</div><div class="mbtt-legend">${legend}</div>`;
    },
    tooltipHtml(varName, groupName, value, detail, key, side) {
      const range = this.nombrerangos[this.rangos(value)];
      const badgeHtml =
        this.winnerSide(key) === side
          ? `<span class="mbtt-badge">+${this.fmt1(this.diffAbs(key))} pts</span>`
          : "";
      return `
        <div class="mbtt-title-row">
          <span class="mbtt-title">${escapeHtml(varName)}</span>
          ${badgeHtml}
        </div>
        <div class="mbtt-sub">${escapeHtml(groupName)}</div>
        <div class="mbtt-stat"><span class="mbtt-stat-value">${this.fmt1(
          value,
        )}%</span><span class="mbtt-stat-label">${escapeHtml(
        range,
      )}</span></div>
        ${this.distributionHtml(detail, key)}
      `;
    },
    fmt1(n) {
      return (Math.round(n * 10) / 10).toFixed(1);
    },
  },
  watch: {
    selectedA() {
      this.fetchDetail("A");
    },
    selectedB() {
      this.fetchDetail("B");
    },
  },
};
</script>

<style lang="scss" scoped>
.comparativo-grupos {
  --row-label-w: 105px;
}

.picker-spacer {
  overflow-anchor: none;
}

.comparativo-threshold-note {
  font-size: 0.75rem;
  color: #7a7a7a;
  text-align: center;
  margin: 0 0 10px;
  overflow-anchor: none;
}

.picker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: center;
  position: sticky;
  z-index: 15;
  padding: 10px 0 14px;
  margin: 0 0 4px;
  overflow-anchor: none;
}

.picker-card {
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  padding: 14px 16px;
  transition: padding 0.15s ease, box-shadow 0.15s ease;
  overflow-anchor: none;
}

.picker-label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #7a7a7a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

.id-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #7a7a7a;
  color: #7a7a7a;
  font-size: 0.65rem;
  font-weight: 700;
  background: transparent;
}

.picker-compact-label {
  display: none;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.75rem;
  font-weight: 700;
  color: #7a7a7a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.gsel {
  position: relative;
}

.gsel-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font: inherit;
  font-size: 0.85rem;
  padding: 9px 11px;
  border-radius: 8px;
  border: 1px solid #dbdbdb;
  background: #fafafa;
  color: #363636;
  cursor: pointer;
  text-align: left;
}

.gsel-trigger:hover {
  border-color: #7a7a7a;
}

.gsel-trigger:focus-visible {
  outline: 2px solid #7a7a7a;
  outline-offset: 1px;
}

.gsel-trigger-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gsel-trigger-dep {
  color: #7a7a7a;
}

.gsel-trigger-sep {
  color: #7a7a7a;
  margin: 0 4px;
}

.gsel-trigger-sub {
  font-weight: 600;
}

.gsel-caret {
  flex: none;
  color: #7a7a7a;
  transition: transform 0.15s ease;
}

.gsel.open .gsel-caret {
  transform: rotate(180deg);
}

.gsel-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 30;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 10px;
  box-shadow: 0 10px 24px -8px rgba(0, 0, 0, 0.28);
  padding: 8px;
  max-height: 300px;
  display: flex;
  flex-direction: column;
}

.gsel-search {
  font: inherit;
  font-size: 0.8rem;
  padding: 8px 10px;
  border-radius: 7px;
  border: 1px solid #dbdbdb;
  background: #fafafa;
  color: #363636;
  margin-bottom: 6px;
  flex: none;
}

.gsel-search:focus {
  outline: 2px solid #7a7a7a;
  outline-offset: 1px;
}

.gsel-total-option {
  font-weight: 700;
  background: #f0f0f0;
  margin-bottom: 6px;
  flex: none;
}

.gsel-total-option:hover {
  background: #e6e6e6;
}

.gsel-list {
  overflow-y: auto;
  flex: 1 1 auto;
}

.gsel-group + .gsel-group {
  margin-top: 4px;
}

.gsel-group-label {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7a7a7a;
  padding: 6px 8px 4px;
}

.gsel-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  color: #363636;
  cursor: pointer;
}

.gsel-option:hover {
  background: #f0f0f0;
}

.gsel-option-warning {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fdf0d6;
  color: #9a5a00;
  font-size: 0.72rem;
  font-weight: 700;
  margin-left: 5px;
  vertical-align: middle;
  cursor: default;
}

.gsel-option-n {
  font-size: 0.68rem;
  color: #7a7a7a;
  flex: none;
}

.gsel-empty {
  padding: 10px 8px;
  font-size: 0.78rem;
  color: #7a7a7a;
  text-align: center;
}

.picker-stat {
  margin-top: 12px;
}

.picker-stat-label {
  display: block;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7a7a7a;
  margin-bottom: 2px;
}

.picker-stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.1;
  color: #363636;
}

.picker-stat.is-insufficient .picker-stat-value {
  color: #9a5a00;
}

.picker-stat-compact-label {
  display: none;
  font-size: 0.68rem;
  font-weight: 700;
  color: #7a7a7a;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.picker-stat-warning {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #9a5a00;
  background: #fdf0d6;
  padding: 4px 9px;
  border-radius: 20px;
  width: fit-content;
}

.picker.is-stuck {
  grid-template-columns: var(--row-label-w) 1fr 1fr var(--row-label-w);
  gap: 16px;
  padding: 7px 0 9px;
}

.picker.is-stuck .picker-compact-label {
  display: flex;
  height: 100%;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  padding: 7px 12px;
  box-shadow: 0 8px 14px -9px rgba(0, 0, 0, 0.3);
  visibility: hidden;
}

.picker.is-stuck .picker-card {
  padding: 7px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 14px -9px rgba(0, 0, 0, 0.3);
}

.picker.is-stuck .picker-label {
  margin-bottom: 0;
  flex: none;
  order: 0;
}

.picker.is-stuck .picker-label-text {
  display: none;
}

.picker.is-stuck .gsel {
  flex: 1 1 auto;
  min-width: 0;
  order: 2;
}

.picker.is-stuck .gsel-trigger {
  padding: 6px 9px;
  font-size: 0.8rem;
}

.picker.is-stuck .picker-stat {
  margin-top: 0;
  flex: none;
  display: flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
  order: 3;
}

.picker.is-stuck .picker-card.a .picker-stat {
  order: 1;
}

.picker.is-stuck .picker-card.a .gsel {
  order: 2;
}

.picker.is-stuck .picker-card.a .picker-label {
  order: 3;
}

.picker.is-stuck .picker-stat-label {
  display: none;
}

.picker.is-stuck .picker-stat-compact-label {
  display: inline;
}

.picker.is-stuck .picker-stat-value {
  font-size: 0.95rem;
}

.picker.is-stuck .picker-stat-warning {
  margin-top: 0;
  padding: 2px 7px;
  font-size: 0.63rem;
  gap: 3px;
}

@media (max-width: 680px) {
  .picker {
    grid-template-columns: 1fr;
  }

  .picker.is-stuck {
    grid-template-columns: 1fr;
  }

  .picker.is-stuck .picker-compact-label {
    display: none;
  }
}

.comparativo-loading {
  padding: 40px 0;
}

.comparativo-loading .progress {
  max-width: 240px;
  margin: 12px auto 0;
}

.comparativo-insights {
  margin: 20px 0 8px;
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 18px 22px;
}

.comparativo-insights-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #7a7a7a;
  margin-bottom: 10px;
}

.comparativo-insight-sides {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 26px;
}

.comparativo-insight-head {
  display: flex;
  align-items: center;
  gap: 7px;
  padding-bottom: 8px;
  margin-bottom: 6px;
  border-bottom: 2px solid #c2c2c2;
}

.comparativo-insight-side-title {
  font-size: 0.85rem;
  font-weight: 700;
}

.comparativo-gap-list {
  min-height: 96px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.comparativo-gap-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.85rem;
  padding: 6px 0;
}

.comparativo-gap-name {
  color: #4a4a4a;
}

.comparativo-gap-value {
  flex: none;
  font-weight: 700;
}

.comparativo-gap-empty {
  font-size: 0.8rem;
  color: #7a7a7a;
  font-style: italic;
  text-align: center;
  margin: 0;
}

@media (max-width: 680px) {
  .comparativo-insight-sides {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}

.comparativo-mirror {
  margin-top: 10px;
  padding: 10px 80px;
}

.mirror-block {
  position: relative;
}

.mirror-block::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 1px;
  background: #c2c2c2;
  pointer-events: none;
}

.mirror-divider {
  display: grid;
  grid-template-columns: var(--row-label-w) 1fr var(--row-label-w);
  column-gap: 14px;
  padding: 4px 0;
}

.mirror-divider-track {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.mirror-divider-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #c2c2c2;
}

.mirror-divider-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #7a7a7a;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.mirror-row {
  display: grid;
  grid-template-columns: var(--row-label-w) 1fr var(--row-label-w);
  align-items: center;
  column-gap: 14px;
  padding: 5px 0;
}

.mirror-row.is-quadrant {
  padding: 8px 0;
  margin-top: 16px;
}

.mirror-header {
  padding: 0;
  margin: 0;
}

.mirror-header-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: #7a7a7a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.mirror-row.is-total {
  padding: 10px 0;
}

.mirror-row.is-quadrant .mirror-row-title {
  font-weight: 700;
  color: #363636;
  font-size: 0.85rem;
}

.mirror-row.is-dim .mirror-row-title {
  color: #6a6a6a;
  font-weight: 400;
  font-size: 0.78rem;
}

.mirror-row.is-total .mirror-row-title {
  font-weight: 700;
  font-size: 1rem;
}

.mirror-row-title {
  font-size: 0.8rem;
  text-align: right;
}

.mirror-track {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 8px;
  height: 20px;
}

.mirror-row.is-quadrant .mirror-track {
  height: 26px;
}

.mirror-row.is-total .mirror-track {
  height: 32px;
}

.mirror-half {
  display: flex;
  align-items: center;
  height: 100%;
}

.mirror-half.left {
  justify-content: flex-end;
}

.mirror-half.right {
  justify-content: flex-start;
}

.mirror-bar {
  height: 12px;
  border-radius: 2px;
  cursor: default;
}

.mirror-row.is-quadrant .mirror-bar {
  height: 17px;
}

.mirror-row.is-total .mirror-bar {
  height: 21px;
}

.mirror-half.is-winner .mirror-bar {
  box-shadow: 0 0 0 1px rgba(11, 11, 11, 0.32),
    0 3px 7px -1px rgba(11, 11, 11, 0.6);
}

.mirror-row.is-dim .mirror-half.is-winner .mirror-bar,
.mirror-row.is-central .mirror-half.is-winner .mirror-bar {
  height: 15px;
}

.mirror-row.is-quadrant .mirror-half.is-winner .mirror-bar {
  height: 20px;
}

.mirror-row.is-total .mirror-half.is-winner .mirror-bar {
  height: 24px;
}

.mirror-half.is-winner .mirror-val {
  color: #15803d;
  font-weight: 800;
}

.mirror-val {
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  width: 42px;
  flex: none;
}

.mirror-row.is-quadrant .mirror-val,
.mirror-row.is-total .mirror-val {
  font-size: 0.85rem;
  font-weight: 700;
}

.mirror-half.is-winner .mirror-val {
  font-weight: 800;
}

.mirror-half.left .mirror-val {
  text-align: right;
  margin-right: 6px;
  order: -1;
}

.mirror-half.right .mirror-val {
  text-align: left;
  margin-left: 6px;
}

.mirror-axis {
  width: 1px;
  align-self: stretch;
}

@media (max-width: 680px) {
  .mirror-row {
    display: block;
  }

  .mirror-row-title {
    text-align: left;
    margin-bottom: 4px;
  }
}
</style>

<!-- Non-scoped: v-tooltip renders at <body>, el estilo del tooltip debe ser global. -->
<style lang="scss">
.mirror-bar-tooltip {
  max-width: 300px !important;

  .tooltip-inner {
    background: #0f0f0f;
    text-align: left;
    padding: 10px 12px;
    border-radius: 10px;
  }
  .tooltip-arrow {
    border-color: #0f0f0f;
  }

  .mbtt-title-row {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .mbtt-title {
    font-weight: 700;
    font-size: 12.5px;
    color: #fff;
  }
  .mbtt-badge {
    font-size: 10px;
    font-weight: 700;
    color: #6fcf6f;
    background: rgba(111, 207, 111, 0.15);
    border-radius: 8px;
    padding: 1px 6px;
    white-space: nowrap;
  }
  .mbtt-sub {
    color: rgba(255, 255, 255, 0.85);
    font-size: 11px;
    margin-bottom: 7px;
  }
  .mbtt-stat {
    display: flex;
    align-items: baseline;
    gap: 7px;
    margin-bottom: 9px;
  }
  .mbtt-stat-value {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }
  .mbtt-stat-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.9);
  }
  .mbtt-empty {
    font-size: 11.5px;
    color: rgba(255, 255, 255, 0.85);
  }
  .mbtt-bar {
    display: flex;
    height: 6px;
    border-radius: 3px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.14);
    margin-bottom: 7px;
  }
  .mbtt-bar span {
    height: 100%;
  }
  .mbtt-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
  }
  .mbtt-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.85);
    white-space: nowrap;
  }
  .mbtt-val {
    color: #fff;
    font-weight: 700;
  }
  .mbtt-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/tabs/GroupComparison.vue